import { loadView } from '@/router'
import billing from './billing'
import configuration from './configuration'
import customerService from './customer-service'
import freight from './freight'
import manage from './manage'
import reports from './reports'
import sales from './sales'
import store from '@/store'

export default [
  {
    path: '/app',
    name: 'application',
    component: loadView('Application'),
    redirect: () => {
      const centralRoute = store.getters['configuration/layout/central']
      return {
        name: centralRoute || 'customerservice'
      }
    },
    children: [
      ...billing,
      ...configuration,
      ...customerService,
      ...freight,
      ...manage,
      ...reports,
      ...sales
    ]
  }
]
